module.exports = __webpack_public_path__ + "img/sup-back.4b6682eb.png";